import { faColor, faCssVar, faRadius } from "@riq/ui/design-tokens";

export type EmbedThemeName = "dark" | "light";

/** CSS custom properties consumed by the embed shadow styles */
export type EmbedThemeVars = Record<string, string>;

export const EMBED_THEME_DARK: EmbedThemeVars = {
  [faCssVar.background]: faColor.background,
  [faCssVar.moduleBg]: faColor.moduleBg,
  [faCssVar.surfaceContainerHighest]: faColor.surfaceContainerHighest,
  [faCssVar.primary]: faColor.primary,
  [faCssVar.primaryContainer]: faColor.primaryContainer,
  [faCssVar.onPrimary]: faColor.onPrimary,
  [faCssVar.onSurface]: faColor.onSurface,
  [faCssVar.onSurfaceVariant]: faColor.onSurfaceVariant,
  [faCssVar.live]: faColor.live,
  [faCssVar.outline]: faColor.outline,
  [faCssVar.outlineVariant]: faColor.outlineVariant,
  [faCssVar.error]: faColor.error,
  [faCssVar.errorContainer]: faColor.errorContainer,
  [faCssVar.onError]: faColor.onError,
  [faCssVar.radiusMd]: faRadius.md,
};

/** Light card preset for white host pages — embed-specific, not in global @riq/ui */
export const EMBED_THEME_LIGHT: EmbedThemeVars = {
  ...EMBED_THEME_DARK,
  [faCssVar.moduleBg]: "#ffffff",
  [faCssVar.onSurface]: faColor.moduleBg,
  [faCssVar.onSurfaceVariant]: faColor.outlineVariant,
  [faCssVar.surfaceContainerHighest]: "#f0f2f5",
  [faCssVar.outlineVariant]: "#d0d5dc",
  /** Lighter amber fill for AA contrast with dark on-primary text on white card */
  [faCssVar.primaryContainer]: "#b89200",
};

export function normalizeEmbedTheme(value: string | null | undefined): EmbedThemeName {
  return value === "light" ? "light" : "dark";
}

export function themeVarsToCssBlock(vars: EmbedThemeVars, indent = "  "): string {
  return Object.entries(vars)
    .map(([name, value]) => `${indent}${name}: ${value};`)
    .join("\n");
}
